module.exports = "https://www.gc-pro.gnp.com.mx/ec4678ff49a3a46dd0b52e171784c849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/20.svg
// module id = 8042
// module chunks = 0